var map = {
	"./de-CH.json": [
		11854,
		1854
	],
	"./de-DE.json": [
		37862,
		7862
	],
	"./en-CA.json": [
		98457,
		8457
	],
	"./en-GB.json": [
		89516,
		9516
	],
	"./en-US.json": [
		40085,
		85
	],
	"./es-ES.json": [
		40852,
		852
	],
	"./fr-FR.json": [
		85876,
		5876
	],
	"./it-IT.json": [
		39246,
		9246
	],
	"./nl-NL.json": [
		14896,
		4896
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85635;
module.exports = webpackAsyncContext;